import { useGate } from "statsig-react";

import config from "#config";
import NotFoundPage from "#utility-pages/not-found-page";

import { MarketplaceLayout } from "./layout";

export const MarketplaceRouteGate = () => {
    const isMarketplaceOnboardingEnabled = useGate(
        config.featureGates.marketplaceOnboarding,
    ).value;
    const isLocalDevelopmentWithoutStatsig =
        config.env === "development" && !config.STATSIG_KEY;

    if (!isMarketplaceOnboardingEnabled && !isLocalDevelopmentWithoutStatsig) {
        return <NotFoundPage />;
    }

    return <MarketplaceLayout />;
};
